<template>
    <SettingsPage title="Elektronische Preisetiketten registrieren">
        <select v-model="selectedPharmacy">
            <option v-for="(option, index) in pharmacies" :key="index" :value="option">
                {{ option.name }}
            </option>
        </select>
        <label>
            .csv-Datei
            <input id="file" ref="file" type="file" accept=".csv" @change="handleFileUpload" />
        </label>
        <SmartButton :disabled="!file || !selectedPharmacy" variant="primary" @click="submitUpload">
            {{ file ? file.name : "Datei" }} hochladen
        </SmartButton>
    </SettingsPage>
</template>

<script>
import SettingsPage from "@/views/menu_pages/SettingsPage";
import SmartButton from "@/views/shared/widgets/SmartButton";
import { DataV2API } from "@/store/api/Endpoints";

export default {
    name: "Label",
    components: { SmartButton, SettingsPage },
    data: function() {
        return {
            file: null,
            selectedPharmacy: undefined
        };
    },
    computed: {
        pharmacies() {
            return this.$store.state.data.pharmacies;
        }
    },
    methods: {
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            console.log(this.file);
        },
        submitUpload() {
            let formData = new FormData();
            formData.append("file", this.file);
            return DataV2API.upload("/label/" + this.selectedPharmacy.id, formData);
        }
    }
};
</script>

<style scoped>
#settingpage > * {
    margin-bottom: 08px;
}
</style>
